


















































import { getModule } from "vuex-module-decorators";
import { Component, Vue, Prop } from "vue-property-decorator";
import MultiplexingGraphConfig from "./data/MultiplexingGraphConfig";
import * as qlog from '@/data/QlogSchema';

import ConnectionConfigurator from "@/components/shared/ConnectionConfigurator.vue";
import ConnectionStore from "@/store/ConnectionStore";
import ConnectionGroup from "@/data/ConnectionGroup";
import Connection from "@/data/Connection";
import QlogConnection from '@/data/Connection';

@Component({
    components: {
        ConnectionConfigurator,
    },
})
export default class MultiplexingGraphConfigurator extends Vue {
    @Prop()
    public config!: MultiplexingGraphConfig;

    public store:ConnectionStore = getModule(ConnectionStore, this.$store);

    public onConnectionSelected(connection:Connection) {
        console.log("MultiplexingGraphConfigurator:onConnectionSelected : ", this.config, connection);

        this.config.connections = [ connection ];
    }

    public get allowSelectAll() : boolean {
        // e.g., add ?multimultiplexing=true to the URL 
        return  (window.location.toString().indexOf(":8080") >= 0) || 
                (window.location.toString().indexOf("localhost") >= 0) || 
                (window.location.toString().indexOf("multimultiplexing") >= 0); // only for local testing for now! // TODO: CLEAN UP
    }

    public selectAllConnections() {

        // TODO: just for paper results, remove!
        (window as any).holblockinfo = new Array<any>();

        let conns = [];
        for ( const group of this.store.groups ){
            //if ( group.filename.indexOf("DEMO") < 0 ){
                conns.push( ...group.getConnections() );
            //}
        }

        // sort on filename. 
        // Otherwise, they're sorted in whatever order they were actually loaded from the filesystem, 
        // which seems wholly indeterministic.
        conns = conns.sort( (c1, c2) => (c1.parent.filename < c2.parent.filename) ? -1 : 1 );

        this.config.showwaterfall = true;
        this.config.showbyteranges = false;
        this.config.connections = conns;
    }

    public mounted(){
        if ( this.config.connections.length === 0 && this.store.groups.length > 0 ){
            this.selectDefault();
        }
    }

    public updated(){
        if ( this.config.connections.length === 0 && this.store.groups.length > 0 ){
            this.selectDefault();
        }
    }

    protected selectDefault(){
        console.log("MultiplexingGraphConfigurator:selectDefault: adding new default connection configurator", this.store.groups);
        this.config.connections = [ this.store.groups[0].getConnections()[0] ];
    }
}

